import Utils from "../../Shared/Utils";
import AudioManager from "../../Shared/AudioManager";
import EnterSoundManager from "../../Shared/EnterSoundManager";
import Constant from "../../Shared/Constant";

const {ccclass, property} = cc._decorator;

@ccclass
export default class XimaLayer extends cc.Component {

    @property(cc.ToggleContainer)
    toggleContainer: cc.ToggleContainer = null
    
    @property(cc.Widget)
    wgtNode: cc.Widget = null;
    @property(cc.Node)
    nodeZiZhuXiMa: cc.Node = null;
    @property(cc.Node)
    nodeXiMaJiLu: cc.Node = null;
    @property(cc.Node)
    nodeXiMaBili: cc.Node = null;

    onLoad () {
        if (cc.winSize.width / cc.winSize.height > 2) {
            this.wgtNode.left += Constant.BangLength;
        }
        this.node.active = true;
        this.nodeZiZhuXiMa.active = true;
        this.nodeXiMaJiLu.active = false;
        this.nodeXiMaBili.active = false;
        //this.node.getChildByName("details").active = false;
        Utils.hideGameNode();
    }

    start () {
        EnterSoundManager.playSound("enter_xima")
    }

    onEnable(): void {
        this.node.getComponent(cc.Animation).play("enter_xima")
    }

    onBtnClick (event, userData) {
        if (userData === "back") {
            console.log("rich=== 点击返回按钮");
            AudioManager.playSound("close")
            Utils.showGameNode();
            this.node.destroy();
        }
    }
    
    onToggleSelected (event, eventData) {
        AudioManager.playSound("toggle")
        if (eventData === "zizhuxima"){
            this.nodeZiZhuXiMa.active = true;
            this.nodeXiMaJiLu.active = false;
            this.nodeXiMaBili.active = false;
        }else if (eventData === "ximajilu"){
            this.nodeZiZhuXiMa.active = false;
            this.nodeXiMaJiLu.active = true;
            this.nodeXiMaBili.active = false;
        }else if (eventData === "ximabili"){
            this.nodeZiZhuXiMa.active = false;
            this.nodeXiMaJiLu.active = false;
            this.nodeXiMaBili.active = true;
        }
    }
}
